import { render, staticRenderFns } from "./pacs.vue?vue&type=template&id=383d3ea4"
import script from "./pacs.vue?vue&type=script&lang=js"
export * from "./pacs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports